import React, { PropTypes } from "react";
import B from "bem-cn";
import "./index.scss";

import { animateScroll } from "react-scroll";
import { scrollToElement } from "../../utils/scroll";
import Input from "react-toolbox/lib/input";
import { Button } from "react-toolbox/lib/button";

const cl = B("Footer");

export default class Footer extends React.Component {
  static propTypes = {
    setOverlay: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      email: "",
    };
  }

  onClickScrollUp() {
    animateScroll.scrollToTop();
  }

  setOverlay = (e, overlay) => {
    e.preventDefault();
    const { setOverlay } = this.props;

    setOverlay(overlay);
  };

  handleAnchorClick = (e) => {
    const el = e.currentTarget;
    const href = el.getAttribute("href");
    const checkHash = href.indexOf("#");
    if (checkHash === 0) {
      e.preventDefault();
      scrollToElement(href.substr(checkHash));
      location.hash = href.substr(checkHash);
    }
  };

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <div className={cl} id="footer">
        <div className={cl("subscribeBlock")}>
          <div className="container-flex">
            <div className={cl("title")}>
              Subscribe to
              <span className={cl("serviceName")}>AKINGO</span>
              <span>News</span>
            </div>
            <div className={cl("form")}>
              <form
                action="//akingo.us15.list-manage.com/subscribe/post?u=97ca588b559c19113e3224dba&amp;id=0c9583250a"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                target="_blank"
                noValidate
                className={cl("submitForm")}
              >
                <Input
                  theme={{
                    input: cl("submitForm")("emailContainer")("input"),
                    bar: cl("submitForm")("emailContainer")("bar"),
                  }}
                  type="email"
                  value={this.state.email}
                  name="EMAIL"
                  id="mce-EMAIL"
                  placeholder="Your e-mail"
                  onChange={this.handleChange.bind(this, "email")}
                />

                <div
                  style={{ position: "absolute", left: "-5000px" }}
                  aria-hidden="true"
                >
                  <input
                    type="text"
                    name="b_97ca588b559c19113e3224dba_0c9583250a"
                    tabIndex="-1"
                    value=""
                  />
                </div>
                <Button
                  raised
                  primary
                  className={cl("submitForm")("btn").toString()}
                  type="submit"
                  label="Subscribe"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                />
              </form>
            </div>
          </div>
        </div>
        <div className={cl("summary")}>
          <div className="container">
            <button
              className={cl("scrollUp")}
              type="button"
              aria-label="Scroll up"
              onClick={this.onClickScrollUp}
            />

            <div className="row">
              <div className="col-md-2 col-sm-4 col-xs-12">
                <div className={cl("columnTitle")}>AKINGO</div>
                <ul className={cl("columnList")}>
                  <li>
                    <a onClick={this.handleAnchorClick} href="#solution">
                      L\xF6sung
                    </a>
                  </li>
                  <li>
                    <a onClick={this.handleAnchorClick} href="#benefits">
                      Benefits
                    </a>
                  </li>
                  <li>
                    <a onClick={this.handleAnchorClick} href="#examples">
                      Examples
                    </a>
                  </li>
                  <li>
                    <a onClick={this.handleAnchorClick} href="#vision">
                      Vision
                    </a>
                  </li>
                  <li>
                    <a onClick={this.handleAnchorClick} href="#technology">
                      Technology
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3 col-md-offset-4 col-sm-4 col-xs-12">
                <div className={cl("columnTitle")}>Kontakt</div>
                <ul className={cl("columnList")}>
                  <li>
                    <a
                      href="/de/impressum/"
                      
                    >
                      Impressum
                    </a>
                  </li>
                  <li><a
                      href="/en/akingo/"
                      
                    >
                      Englische Version
                    </a>
</li>
                  <li>Capely GmbH</li>
                  <li>Prinz-Georg-Str. 91</li>
                  <li>40479 Düsseldorf, Germany</li>
                </ul>
              </div>
              <div
                className={cl("descriptionColumn").mix(
                  "col-md-3 col-sm-12 col-xs-12"
                )}
              >
                <div>
                  Made with <span className={cl("heartIcon")} /> from around the
                  world
                </div>
                <div>© 2013-2022{" "}
                  <a
                    href="/"
                             >
                    Capely
                  </a>{" "}
                   - All rights reserved{" "}
                </div>
                <div>
                  Some icons by{" "}
                  <a
                    href="http://www.flaticon.com/authors/freepik"
                    target="_blank"
                  >
                    Freepik
                  </a>{" "}
                  from Flaticon{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/footer/index.jsx